import BaseService from './base.service';

export default class AssociateMemberService {
    static ENDPOINT = '/orgs';

    static async addAssociateMember(orgId, propertyId, payload) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/associate-members`;
        return BaseService.post(endpoint, payload);
    }

    static async updateAssociateMember(orgId, propertyId, id, payload) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/associate-members/${id}`;
        return BaseService.patch(endpoint, payload);
    }

    static async deleteAssociateMember(orgId, propertyId, id) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/associate-members/${id}`;
        return BaseService.delete(endpoint);
    }

    static async addVehicle(orgId, propertyId, id, payload) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/associate-members/${id}/vehicles`;
        return BaseService.post(endpoint, payload);
    }

    static async updateVehicle(orgId, propertyId, id, tag, payload) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/associate-members/${id}/vehicles/${encodeURIComponent(tag)}`;
        return BaseService.patch(endpoint, payload);
    }

    static async deleteVehicle(orgId, propertyId, id, tag) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/associate-members/${id}/vehicles/${encodeURIComponent(tag)}`;
        return BaseService.delete(endpoint);
    }
}
